module.exports = __webpack_public_path__ + "img/rain.c178b83e.svg";